import React, { useState, useEffect } from "react";
import { database } from "../firebase";
import { Helmet } from "react-helmet-async";
import { ref, get, child, update, push, onValue } from "firebase/database";
import { Link, useParams } from "react-router-dom";

const Forums = ({ title, description }) => {
  const { forumId } = useParams();
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState({});
  const [newPost, setNewPost] = useState("");
  const [newComment, setNewComment] = useState({});
  const [showCreatePost, setShowCreatePost] = useState(false);
  const userId = "prestigeflight2022_gmail_com"; // Replace with actual user auth

  useEffect(() => {
    const dbRef = ref(database, `forums/${forumId || "global"}/posts`);
    const usersRef = ref(database, "users");

    const unsubscribe = onValue(dbRef, (snapshot) => {
      if (snapshot.exists()) {
        setPosts(Object.entries(snapshot.val()).map(([id, data]) => ({ id, ...data })));
      }
    });

    get(usersRef).then((snapshot) => {
      if (snapshot.exists()) {
        setUsers(snapshot.val());
      }
    });

    return () => unsubscribe();
  }, [forumId]);

  const handleCreatePost = async () => {
    if (!newPost.trim()) return;
    const postRef = push(ref(database, `forums/${forumId || "global"}/posts`));
    const postData = {
      title: "New Post",
      content: newPost,
      author: userId,
      timestamp: new Date().toISOString(),
      upvotes: 0,
      downvotes: 0,
      votes: {},
      comments: {},
      tags: [],
    };
    await update(postRef, postData);
    setNewPost("");
    setShowCreatePost(false);
  };

  const handleComment = async (postId) => {
    if (!newComment[postId]?.trim()) return;
    const commentRef = push(ref(database, `forums/${forumId || "global"}/posts/${postId}/comments`));
    const commentData = {
      content: newComment[postId],
      author: userId,
      timestamp: new Date().toISOString(),
    };
    await update(commentRef, commentData);
    setNewComment((prev) => ({ ...prev, [postId]: "" }));
  };

  const handleVote = async (postId, type) => {
    const postRef = ref(database, `forums/${forumId || "global"}/posts/${postId}`);
    const postSnapshot = await get(postRef);
    if (postSnapshot.exists()) {
      const postData = postSnapshot.val();
      const userVote = postData.votes?.[userId];
      
      let updatedUpvotes = postData.upvotes;
      let updatedDownvotes = postData.downvotes;
      let updatedVotes = { ...postData.votes };

      if (userVote === type) {
        // Remove vote if already voted
        updatedUpvotes -= type === "upvote" ? 1 : 0;
        updatedDownvotes -= type === "downvote" ? 1 : 0;
        delete updatedVotes[userId];
      } else {
        // Change vote
        if (userVote === "upvote") updatedUpvotes--;
        if (userVote === "downvote") updatedDownvotes--;
        
        updatedUpvotes += type === "upvote" ? 1 : 0;
        updatedDownvotes += type === "downvote" ? 1 : 0;
        updatedVotes[userId] = type;
      }

      await update(postRef, { upvotes: updatedUpvotes, downvotes: updatedDownvotes, votes: updatedVotes });
    }
  };

  return (
    <div className="frm-bg">
    <div className="frm-container">
      <Helmet>
        <title>{title || 'Global Forum - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Global Forum of EnbyBase Alliance'} />
    <meta property="og:title" content={title || 'Global Forum - EnbyBase Official Website'}/>
    <meta property="og:description" content={description || 'Global Forum of EnbyBase Alliance'}/>
      </Helmet>
      <h1 className="frm-title">{forumId ? `${forumId} Forum` : "Global Forum"}</h1>
      <button onClick={() => setShowCreatePost(!showCreatePost)} className="frm-toggle-button">
        {showCreatePost ? "Hide" : "Create a Post"}
      </button>
      {showCreatePost && (
        <div className="frm-create-post">
          <textarea value={newPost} onChange={(e) => setNewPost(e.target.value)} placeholder="Write a new post..." className="frm-textarea" />
          <button onClick={handleCreatePost} className="frm-button">Post</button>
        </div>
      )}
      {posts.map((post) => {
        const author = users[post.author];
        const userVote = post.votes?.[userId];
        return (
          <div key={post.id} className="frm-post-card">
            <div className="frm-post-header">
              <img src={author?.pronounscard?.profileImage} alt={author?.nickname} className="frm-author-img" />
              <Link to={`/u/${author?.nickname}`} className="frm-author-name">{author?.nickname}</Link>
              <span className="frm-timestamp">{new Date(post.timestamp).toLocaleString()}</span>
            </div>
            <h2 className="frm-post-title">{post.title}</h2>
            <p className="frm-post-content">{post.content}</p>
            <div className="frm-post-footer">
              <button 
                onClick={() => handleVote(post.id, "upvote")} 
                className={`frm-vote-button ${userVote === "upvote" ? "frm-upvoted" : ""}`}
              >
                ⬆ {post.upvotes}
              </button>
              <button 
                onClick={() => handleVote(post.id, "downvote")} 
                className={`frm-vote-button ${userVote === "downvote" ? "frm-downvoted" : ""}`}
              >
                ⬇ {post.downvotes}
              </button>
              <span className="frm-comments">💬 {Object.keys(post.comments || {}).length} Comments</span>
            </div>
            <div className="frm-comment-section">
              {Object.values(post.comments || {}).map((comment, index) => (
                <div key={index} className="frm-comment">
                  <strong>{users[comment.author]?.nickname || "Unknown"}</strong>: {comment.content}
                </div>
              ))}
              <textarea value={newComment[post.id] || ""} onChange={(e) => setNewComment((prev) => ({ ...prev, [post.id]: e.target.value }))} placeholder="Write a comment..." className="frm-textarea" />
              <button onClick={() => handleComment(post.id)} className="frm-button">Comment</button>
            </div>
          </div>
        );
      })}
    </div></div>
  );
};

export default Forums;
